import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Notifications from 'vue-notification'
Vue.use(Notifications)
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
import axios from 'axios'
Vue.use(VueAxios, axios)
import VueAxios from 'vue-axios'
import money from 'v-money'
Vue.use(money, { precision: 4 })
import vSelect from "vue-select"
Vue.component("v-select", vSelect)
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: '.',
  fractionCount: 0,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
import VSwitch from 'v-switch-case'
Vue.use(VSwitch)
import vmodal from 'vue-js-modal'
Vue.use(vmodal)
import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  defaultHtml: true,
})
Vue.config.productionTip = false
Vue.prototype.$api_key = 'c628a195-14c7-4876-a678-0811cef53830'
//Vue.prototype.$base_url = 'https://arboledadev.com/reddy/api/index.php///https://api.reddycolombia.com/index.php/'
switch (process.env.NODE_ENV) {
  case "production":
    Vue.prototype.$base_url = 'https://reddytech.com.co/api/index.php/'
    break;
  default:
    Vue.prototype.$base_url = "https://reddytech.com.co/api/index.php/";
    break;
}
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
